export default __webpack_public_path__ + "static/001-1895ad874a85b5e4e34f8f7bd364b698.jpg";